import React, { FunctionComponent } from 'react';

import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';
import { InsuredItem } from 'scenes/common/types';
import { getPropertyOccupancy } from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';

export const QUESTION = `Do 5 or more unrelated people live in the ${InsuredItem.Home}?`;
const PROPERTY_OCCUPANCY = 'propertyOccupancy';

const PropertyOccupancyStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={PROPERTY_OCCUPANCY}
    defaultStateValue={getPropertyOccupancy(funnelState)}
    onNext={onNext}
  />
);

export default PropertyOccupancyStep;
